import React from "react"
import { useHistory } from "react-router-dom"

import { NotificationDetailActionButton } from "@/components/Notifications/NotificationDetailActionButton"
import type { ButtonProps } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import type { NotificationDetailAction } from "@/utils/notificationDetailActions"

function actionButtonVariant(actionId: string): ButtonProps["variant"] {
  if (actionId === "statistics") return "outline-brand"
  if (actionId === "trade-review") return "outline-gray"
  if (
    actionId === "reconnect" ||
    actionId === "check-sync" ||
    actionId === "manage-payment" ||
    actionId === "try-again-report"
  ) {
    return "gradient-red"
  }
  if (actionId === "confirm-payment") return "gradient-orange"
  if (
    actionId === "view-connection" ||
    actionId === "view-billing" ||
    actionId === "view-report" ||
    actionId === "reactivate" ||
    actionId === "announcement-cta"
  ) {
    return "gradient"
  }
  return "gradient"
}

export function NotificationDetailActionsPanel({
  actions,
  className,
  layout = "row",
}: {
  actions: NotificationDetailAction[]
  className?: string
  layout?: "row" | "stack"
}): React.ReactElement | null {
  const history = useHistory()

  if (actions.length === 0) {
    return null
  }

  return (
    <div
      data-notification-detail-actions=""
      data-notification-detail-actions-layout={layout}
      className={cn(
        layout === "stack"
          ? "flex w-full flex-col items-stretch gap-2"
          : "flex flex-wrap items-center gap-2",
        className
      )}
    >
      {actions.map((action) => (
        <NotificationDetailActionButton
          key={action.id}
          label={action.buttonLabel}
          dataAttr={action.id}
          variant={actionButtonVariant(action.id)}
          onClick={() => {
            if (action.external) {
              window.open(action.path, "_blank", "noopener,noreferrer")
              return
            }
            history.push(action.path)
          }}
          className={layout === "stack" ? "w-full justify-center" : undefined}
        />
      ))}
    </div>
  )
}
